module.exports = __webpack_public_path__ + "img/6_159.eeece86b.png";